var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"m-r p-r"},[_c('el-alert',{staticClass:"m-t m-b m-l",attrs:{"type":"error","closable":false,"effect":"dark","center":""}},[_vm._t("default",function(){return [_vm._v(_vm._s(_vm.$t('unauthorized.read')))]})],2)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }